exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".global_message{width:102px;height:102px;border-radius:4px;position:fixed;z-index:99999;top:50%;margin-top:-56px;left:156px;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.global_message.dialog_recon{top:32vh;left:50%;margin-left:-51px}.global_message .global_message_icon{width:62px;height:62px}.global_message .global_message_text{font-size:16px}.global_message.global_message_warning{background-color:#f36844}.global_message.global_message_success{background-color:#39d287}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/assets/css/global_message.css
// module id = 176
// module chunks = 28